import React, { useCallback, useEffect, useState } from "react";
import { FiTrash2 } from "react-icons/fi";
import { apiRequest } from "../../api";

export default function CoWorkMembersAdmin() {
  const [members, setMembers] = useState(null);
  const [role, setRole] = useState("");

  const load = useCallback(async () => {
    const { ok, data } = await apiRequest(`/core/cowork/members/${role ? `?role=${role}` : ""}`, { auth: true });
    setMembers(ok ? data : []);
  }, [role]);

  useEffect(() => { load(); }, [load]);

  const setActive = async (member, isActive) => {
    await apiRequest(`/core/cowork/members/${member.id}/`, { method: "PATCH", auth: true, body: { is_active: isActive } });
    load();
  };

  const remove = async (member) => {
    if (!window.confirm(`Delete ${member.email}? Their jobs and proposals are deleted too.`)) return;
    await apiRequest(`/core/cowork/members/${member.id}/`, { method: "DELETE", auth: true });
    load();
  };

  return (
    <div className="w-full">
      <h1 className="text-2xl font-bold mb-2">Members</h1>
      <p className="text-sm text-gray-400 mb-6">
        Registered buyers and sellers. Untick "Active" to block someone from signing in without deleting their data.
      </p>

      <div className="flex gap-2 mb-4">
        {[["", "All"], ["buyer", "Buyers"], ["seller", "Sellers"]].map(([key, label]) => (
          <button key={key} onClick={() => setRole(key)} className={`px-4 py-1.5 rounded-full text-sm ${role === key ? "bg-brand-gradient text-white" : "bg-white/5 border border-navy-border text-gray-300"}`}>
            {label}
          </button>
        ))}
      </div>

      <div className="bg-navy border border-navy-border rounded-xl overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-white/5 text-gray-400 text-left">
            <tr>
              <th className="px-4 py-3">Member</th>
              <th className="px-4 py-3">Role</th>
              <th className="px-4 py-3">Contact</th>
              <th className="px-4 py-3">Activity</th>
              <th className="px-4 py-3">Joined</th>
              <th className="px-4 py-3 w-20">Active</th>
              <th className="px-4 py-3 w-16"></th>
            </tr>
          </thead>
          <tbody>
            {(members || []).map((m) => (
              <tr key={m.id} className="border-t border-navy-border align-top">
                <td className="px-4 py-3">
                  <p className="text-white font-medium">{m.full_name || "—"}</p>
                  <p className="text-xs text-gray-500">{m.email}</p>
                </td>
                <td className="px-4 py-3">
                  <span className={`px-2.5 py-1 rounded-full text-xs capitalize ${m.role === "buyer" ? "bg-sky-500/15 text-sky-400" : "bg-violet-500/15 text-violet-400"}`}>{m.role}</span>
                </td>
                <td className="px-4 py-3 text-xs text-gray-300">{m.phone || "—"}<br />{[m.company || m.headline, m.country].filter(Boolean).join(" · ")}</td>
                <td className="px-4 py-3 text-xs text-gray-300">{m.role === "buyer" ? `${m.jobs_count} jobs` : `${m.proposals_count} proposals`}</td>
                <td className="px-4 py-3 text-xs text-gray-400">{new Date(m.date_joined).toLocaleDateString()}</td>
                <td className="px-4 py-3"><input type="checkbox" checked={m.is_active} onChange={(e) => setActive(m, e.target.checked)} /></td>
                <td className="px-4 py-3">
                  <button onClick={() => remove(m)} className="p-1.5 rounded-md text-red-400 hover:bg-red-500/10" aria-label="Delete"><FiTrash2 size={14} /></button>
                </td>
              </tr>
            ))}
            {members && members.length === 0 && (
              <tr><td colSpan={7} className="px-4 py-6 text-center text-gray-500">No members yet.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
